export const categories = [
  {
    slug: "pol-scandal",
    name: "政客丑闻",
    shortName: "丑闻",
    description:
      "从游说金流到私人行程，我们把公开记录里对不上的时间线与资金链一条条摆出来，还原政客台面下的关系网。",
    icon: "ri-user-star-line",
    count: 42,
  },
  {
    slug: "mogul",
    name: "财阀内幕",
    shortName: "财阀",
    description:
      "家族商社、老牌财团、离岸架构——关注资本如何在董事会与继承权之间完成一次安静的转移。",
    icon: "ri-building-2-line",
    count: 35,
  },
  {
    slug: "corruption",
    name: "官员贪腐",
    shortName: "贪腐",
    description:
      "批文、招标、饭局与转包。我们追踪那些藏在流程里的灰色节点，记录一桩桩被拖了很久的案子。",
    icon: "ri-scales-3-line",
    count: 51,
  },
  {
    slug: "election",
    name: "选举黑幕",
    shortName: "选举",
    description:
      "计票异常、民调操控、动员名单买卖。围绕每一次投票日前后，整理可核对的疑点与复盘。",
    icon: "ri-checkbox-multiple-line",
    count: 28,
  },
  {
    slug: "corporate",
    name: "企业造假",
    shortName: "造假",
    description:
      "财报里的空仓库、调包的质检报告。把企业自述与监管文件对照，看数字是怎么被做出来的。",
    icon: "ri-file-chart-line",
    count: 39,
  },
  {
    slug: "academic",
    name: "学术不端",
    shortName: "学术",
    description:
      "图像复用、评审闭环、挂名署名。以可复现的方式，记录科研诚信领域被反复提起的争议。",
    icon: "ri-flask-line",
    count: 23,
  },
];